import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Flex } from "@xingternal/winery-ui/lib/Flex"
import { Loading } from "@xingternal/winery-ui/lib/Loading"

const Wrapper = styled(Flex)`
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  min-width: 1px;
  min-height: 0;
  height: ${({ root }) => root && "100vh"};
`

const LoadingFullScreen = (props) => (
  <Wrapper {...props}>
    <Loading />
  </Wrapper>
)

LoadingFullScreen.propTypes = {
  root: PropTypes.bool,
}

export { LoadingFullScreen }
